import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const AI = () => {
  const services = [
    {
      icon: FiIcons.FiCpu,
      title: 'Machine Learning',
      description: 'Implementación de algoritmos de aprendizaje automático para análisis predictivo y toma de decisiones.'
    },
    {
      icon: FiIcons.FiMessageSquare,
      title: 'Chatbots Inteligentes',
      description: 'Desarrollo de asistentes virtuales personalizados para atención al cliente 24/7.'
    },
    {
      icon: FiIcons.FiTrendingUp,
      title: 'Análisis Predictivo',
      description: 'Predicción de tendencias y comportamientos mediante IA para optimizar su negocio.'
    },
    {
      icon: FiIcons.FiSettings,
      title: 'Automatización',
      description: 'Automatización de procesos mediante sistemas inteligentes y RPA.'
    }
  ];

  const benefits = [
    {
      icon: FiIcons.FiClock,
      title: 'Ahorro de Tiempo',
      description: 'Automatización de tareas repetitivas liberando recursos para tareas estratégicas.'
    },
    {
      icon: FiIcons.FiTrendingUp,
      title: 'Mayor Eficiencia',
      description: 'Optimización de procesos y reducción de errores mediante IA.'
    },
    {
      icon: FiIcons.FiTarget,
      title: 'Decisiones Precisas',
      description: 'Análisis de datos avanzado para toma de decisiones informadas.'
    },
    {
      icon: FiIcons.FiUsers,
      title: 'Mejor Experiencia',
      description: 'Atención al cliente personalizada y disponible 24/7.'
    }
  ];

  return (
    <div className="py-16 relative">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12">
          Soluciones de Inteligencia Artificial para Empresas
        </h1>

        {/* Sección de Servicios */}
        <section className="mb-16">
          <h2 className="text-3xl font-semibold text-center mb-8">
            Nuestros Servicios de IA
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
                <SafeIcon icon={service.icon} className="h-12 w-12 text-blue-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Sección de Beneficios */}
        <section className="mb-16">
          <h2 className="text-3xl font-semibold text-center mb-8">
            Beneficios de la IA en su Empresa
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-start bg-gray-50 p-6 rounded-lg">
                <SafeIcon icon={benefit.icon} className="h-8 w-8 text-blue-600 mr-4" />
                <div>
                  <h3 className="font-semibold mb-2">{benefit.title}</h3>
                  <p className="text-gray-600">{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default AI;